import { get, set, del } from 'idb-keyval'
import type {
  PersistedClient,
  Persister,
} from '@tanstack/react-query-persist-client'

// Helper function to serialize data and remove non-serializable objects
function serializeClient(client: PersistedClient): PersistedClient {
  try {
    // Create a deep copy and remove functions/non-serializable data
    const serialized = JSON.parse(JSON.stringify(client, (key, value) => {
      // Handle BigInt values
      if (typeof value === 'bigint') {
        return value.toString()
      }
      // Filter out functions and other non-serializable types
      if (typeof value === 'function') {
        return undefined
      }
      // Filter out symbols
      if (typeof value === 'symbol') {
        return undefined
      }
      // Filter out undefined values
      if (value === undefined) {
        return undefined
      }
      return value
    }))

    return serialized
  } catch (error) {
    console.warn('Failed to serialize client data:', error)
    // Return a minimal client structure if serialization fails
    const fallbackClient = {
      clientState: {
        queries: [],
        mutations: []
      }
    } as any
    return fallbackClient
  }
}

export function createIDBPersister(idbValidKey: IDBValidKey = 'chewyStack69') {
    return {
      persistClient: async (client: PersistedClient) => {
        try {
          const serializedClient = serializeClient(client)
          await set(idbValidKey, serializedClient)
        } catch (error) {
          console.error('Failed to persist client to IndexedDB:', error)
          // Don't throw error to prevent app crashes
        }
      },
      restoreClient: async () => {
        try {
          return await get<PersistedClient>(idbValidKey)
        } catch (error) {
          console.error('Failed to restore client from IndexedDB:', error)
          return undefined
        }
      },
      removeClient: async () => {
        try {
          await del(idbValidKey)
        } catch (error) {
          console.error('Failed to remove client from IndexedDB:', error)
        }
      },
    } as Persister
  }